import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '../../assets/icons/ArrowBackIcon';  // ← Fix circular import
import styles from './ReturnIconButton.css';

type Props = {
  className?: string;
};

const ReturnWithArrowIcon = ({ className }: Props): ReactElement => {
  const { t } = useTranslation();
  const translationRoot = 'ORDER_LIST';

  return (
    <span className={`${styles.container} ${className || ''}`}>
      <ArrowBackIcon />
      <span className={styles.text}>
        {t(`${translationRoot}.LIST_ITEM.RETURN`)}
      </span>
    </span>
  );
};

export default ReturnWithArrowIcon;